import { render, staticRenderFns } from "./FarmOwnerInfo.vue?vue&type=template&id=72c793bb&"
import script from "./FarmOwnerInfo.vue?vue&type=script&lang=ts&"
export * from "./FarmOwnerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./farm-owner-info.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports